import { RequestDefinition } from 'libraries/front-end-core/core/Api'

import {
  toCaseRefs,
  toContent,
  toInstantSearch,
  toQAReferences,
  toSearch,
  toSections
} from './transforms'

import {
  URL_CASE_REFS_CHAPTER,
  URL_QA_CONTENT,
  URL_QA_INSTANTSEARCH,
  URL_QA_REFERENCES,
  URL_QA_SEARCH,
  URL_QA_SEARCH_PREPAY,
  URL_QA_SECTIONS,
  URL_QA_SECTIONS_PREPAY,
  URL_QA_CONTENT_PREPAY
} from 'constants/urls'

import {
  CASE_REFS_CHAPTER,
  QA_CONTENT,
  QA_INSTANTSEARCH,
  QA_REFERENCES,
  QA_SEARCH,
  QA_SEARCH_PREPAY,
  QA_SECTIONS,
  QA_SECTIONS_PREPAY,
  QA_CONTENT_PREPAY
} from 'constants/requests'

export const CaseRefsChapter = new RequestDefinition({
  name: CASE_REFS_CHAPTER,
  url: URL_CASE_REFS_CHAPTER,
  transform: toCaseRefs
})

export const QAContent = new RequestDefinition({
  name: QA_CONTENT,
  url: URL_QA_CONTENT,
  transform: toContent
})

export const QAContentPrepay = new RequestDefinition({
  name: QA_CONTENT_PREPAY,
  url: URL_QA_CONTENT_PREPAY,
  transform: toContent
})

export const QAInstantSearch = new RequestDefinition({
  name: QA_INSTANTSEARCH,
  url: URL_QA_INSTANTSEARCH,
  transform: toInstantSearch
})

export const QAReferences = new RequestDefinition({
  name: QA_REFERENCES,
  url: URL_QA_REFERENCES,
  transform: toQAReferences
})

export const QASearch = new RequestDefinition({
  name: QA_SEARCH,
  url: URL_QA_SEARCH,
  transform: toSearch
})

export const QASearchPrepay = new RequestDefinition({
  name: QA_SEARCH_PREPAY,
  url: URL_QA_SEARCH_PREPAY,
  transform: toSearch
})

export const QASections = new RequestDefinition({
  name: QA_SECTIONS,
  url: URL_QA_SECTIONS,
  transform: toSections
})

export const QASectionsPrepay = new RequestDefinition({
  name: QA_SECTIONS_PREPAY,
  url: URL_QA_SECTIONS_PREPAY,
  transform: toSections
})
